import { BUSINESS_ROLE_GROUPS, ROLES } from '@/components/security/AppRoles';
import { Commerce, CommerceSettings } from '@/pages/Business/pages';
import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';

import {
  NewCommerceSettings,
  EditCommerceSettings,
  NewCommerce,
  EditCommerce,
  CommerceBranches,
  NewBranch,
  EditBranch,
  BranchSettings,
  NewBranchSetting,
  EditBranchSetting,
  IncludedPickupCommerces,
  CommerceIntegrationWizard,
} from '@/pages/Business/pages/Commerce/pages';

import CommerceDashboard from '../CommerceDashboard';
import {
  EditIntegrationRequestPage,
  INTEGRATION_IT_ROLES,
  INTEGRATION_REQUEST_ROLES,
  IntegrationRequestDetailPage,
  IntegrationRequestsPage,
  NewIntegrationRequestPage,
} from '../pages/IntegrationRequests';
import { IntegrationWebhooksPage } from '../pages/IntegrationWebhooks';

const CommerceRoutes: RouteObject[] = [
  {
    path: 'commerce',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.withoutDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <Commerce />
      </Authorize>
    ),
  },
  {
    path: 'commerce/included-pickup-commerces',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.withoutDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <IncludedPickupCommerces />
      </Authorize>
    ),
  },
  {
    path: 'commerce/new',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <NewCommerce />
      </Authorize>
    ),
  },
  {
    path: 'commerce/integration-requests',
    element: (
      <Authorize permission={INTEGRATION_REQUEST_ROLES} fallback={<ErrorPage code={403} />}>
        <IntegrationRequestsPage />
      </Authorize>
    ),
  },
  {
    path: 'commerce/integration-requests/new',
    element: (
      <Authorize permission={INTEGRATION_REQUEST_ROLES} fallback={<ErrorPage code={403} />}>
        <NewIntegrationRequestPage />
      </Authorize>
    ),
  },
  {
    path: 'commerce/integration-requests/:requestId',
    element: (
      <Authorize permission={INTEGRATION_REQUEST_ROLES} fallback={<ErrorPage code={403} />}>
        <IntegrationRequestDetailPage />
      </Authorize>
    ),
  },
  {
    path: 'commerce/integration-requests/:requestId/edit',
    element: (
      <Authorize permission={INTEGRATION_REQUEST_ROLES} fallback={<ErrorPage code={403} />}>
        <EditIntegrationRequestPage />
      </Authorize>
    ),
  },
  {
    path: 'commerce/integration-webhooks',
    element: (
      <Authorize permission={INTEGRATION_IT_ROLES} fallback={<ErrorPage code={403} />}>
        <IntegrationWebhooksPage />
      </Authorize>
    ),
  },
  {
    /**
     * Wizard de integración: crea/elige comercio, sucursal e invita al usuario.
     * Pide permisos de gestión porque el último paso invita usuarios.
     */
    path: 'commerce/integration',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <CommerceIntegrationWizard />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <EditCommerce />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/dashboard',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.withoutDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <CommerceDashboard />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/settings',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <CommerceSettings />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/settings/new',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <NewCommerceSettings />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/settings/:configId/edit',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <EditCommerceSettings />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/branches',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.withoutDispatcher}
        fallback={<ErrorPage code={403} />}
      >
        <CommerceBranches />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/branches/new',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <NewBranch />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/branches/:branchId/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <EditBranch />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/branches/:branchId/settings',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <BranchSettings />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/branches/:branchId/settings/new',
    element: (
      <Authorize
        permission={ROLES.BUSINESS.admin}
        fallback={<ErrorPage code={403} />}
      >
        <NewBranchSetting />
      </Authorize>
    ),
  },
  {
    path: 'commerce/:commerceId/branches/:branchId/settings/:settingId/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <EditBranchSetting />
      </Authorize>
    ),
  },
];

export default CommerceRoutes;
